import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const BASE_NAV = [
  { to: "/", label: "Home" },
  { to: "/principles", label: "Principles" },
  { to: "/data", label: "Live Data" },
  { to: "/database", label: "Criteria Database" },
  { to: "/status", label: "Submission Status" },
  { to: "/advisory", label: "Advisory Board" },
];

export default function Header() {
  const { pathname } = useLocation();
  const [report, setReport] = useState(null);

  useEffect(() => {
    api.get("/report/status").then((r) => setReport(r.data)).catch(() => {});
  }, []);

  const NAV = report?.available
    ? [...BASE_NAV, { to: "/report", label: `${report.year} Report` }]
    : BASE_NAV;

  return (
    <>
      {/* top strip */}
      <div className="bg-navy py-2.5 text-center">
        <span className="text-xs tracking-[0.25em] text-white/90 sm:text-sm">
          Listening. Learning. Improving California's Rental Experience.
        </span>
      </div>

      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
          <Link to="/" data-testid="brand-link" className="flex flex-col leading-none">
            <span className="font-serif text-lg font-semibold tracking-tight text-ink sm:text-xl">
              California Rental Experience Project
            </span>
            <span className="mt-1 text-xs uppercase tracking-[0.22em] text-calblue sm:text-[13px]">
              An Independent Housing Research Initiative
            </span>
          </Link>

          <nav className="hidden items-center gap-6 md:flex">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`text-sm transition-colors ${
                  pathname === n.to ? "text-navy" : "text-slate-600 hover:text-ink"
                }`}
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/#share"
              data-testid="header-share-button"
              className="rounded-none border border-navy px-5 py-2.5 text-sm font-medium text-navy transition-colors hover:bg-navy hover:text-white focus:outline-none focus:ring-2 focus:ring-navy focus:ring-offset-2"
            >
              Add Your Voice
            </Link>
          </nav>

          <Link
            to="/#share"
            data-testid="header-share-button-mobile"
            className="rounded-none border border-navy px-4 py-2 text-xs font-medium text-navy md:hidden"
          >
            Add Your Voice
          </Link>
        </div>
      </header>
    </>
  );
}
